import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
export let ELIGIBILITY_STATUS;

(function (ELIGIBILITY_STATUS) {
  ELIGIBILITY_STATUS["ELIGIBLE"] = "ELIGIBLE";
  ELIGIBILITY_STATUS["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
  ELIGIBILITY_STATUS["NOT_ELIGIBLE_APPLICATION_SUBMITTED"] = "NOT_ELIGIBLE_APPLICATION_SUBMITTED";
  ELIGIBILITY_STATUS["APPLICATION_PENDING"] = "APPLICATION_PENDING";
  ELIGIBILITY_STATUS["PENDING"] = "PENDING";
})(ELIGIBILITY_STATUS || (ELIGIBILITY_STATUS = {}));

export let HSFX_PROGRAMS;

(function (HSFX_PROGRAMS) {
  HSFX_PROGRAMS["STARTUPS_SEED"] = "Startups Seed";
  HSFX_PROGRAMS["STARTUPS_SERIES_A"] = "Startups Series-A";
  HSFX_PROGRAMS["ENTREPRENEUR"] = "Entrepreneur";
  HSFX_PROGRAMS["BOOTSTRAP"] = "Bootstrap";
  HSFX_PROGRAMS["HUBSPOT_STRATEGIC_PARTNER"] = "Strategic Partner";
  HSFX_PROGRAMS["NONPROFIT"] = "Nonprofits";
})(HSFX_PROGRAMS || (HSFX_PROGRAMS = {}));

export const fetchHsfxEligibility = () => {
  const url = `${getFullUrl('app-api')}/hsfx/v1/eligibility/status`;
  return http.get(url, {
    ignoreRedirect: true
  });
};